export default __webpack_public_path__ + "static/ben-wulf-photography-logo-brand-c14f9b1998602f8a900af6a7e4638ccc.jpg";